import { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ToastNotification = ({ message, type = 'success', onUndo, onClose, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return { name: 'CheckCircle2', color: 'var(--color-success)' };
      case 'error':
        return { name: 'XCircle', color: 'var(--color-destructive)' };
      case 'warning':
        return { name: 'AlertCircle', color: 'var(--color-warning)' };
      default:
        return { name: 'Info', color: 'var(--color-primary)' };
    }
  };

  const icon = getIcon();

  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-1/2 md:-translate-x-1/2 md:max-w-md z-[200] animate-slideUp">
      <div className="bg-card rounded-xl border border-border shadow-soft-xl p-4 flex items-center gap-3">
        <div className="flex-shrink-0">
          <Icon name={icon?.name} size={20} color={icon?.color} />
        </div>
        
        <p className="flex-1 text-sm md:text-base text-foreground">
          {message}
        </p>

        {onUndo && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onUndo}
            className="flex-shrink-0"
          >
            Undo
          </Button>
        )}

        <button
          onClick={onClose}
          className="flex-shrink-0 w-8 h-8 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
          aria-label="Close notification"
        >
          <Icon name="X" size={16} color="var(--color-muted-foreground)" />
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;